import { PolicyPage } from 'components/organisms/PolicyPage';

const TermsOfUsePage = () => <PolicyPage id="9d3408ff-cbfb-45b6-b91b-6b3d1b6fff39" />;

export default TermsOfUsePage;
